import { type ReactElement, } from "react";
import { SvgIconBase, } from "./Base";
import { getTheme, } from "@bracket/ui/themes";
import type { ColorDeclaration, } from "@bracket/ui/types";



export declare type TelegramProps = {
	className?: string;
	style?: React.CSSProperties;
	scale?: number;
	accentColor?: ColorDeclaration;
}

export const Telegram = ({
	className = "",
	style = {},
	scale,
}: TelegramProps): ReactElement => {
	return (
		<SvgIconBase
			className={className}
			style={style}
			scale={scale}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
			aria-label="Telegram"
		>
			<title>Telegram</title>
			{/* Rounded square background - uses currentColor */}
			<rect x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
			{/* Paper airplane - official Telegram logo shape from Simple Icons */}
			<path
				fill="#014326"
				d="M16.906 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"
			/>
		</SvgIconBase>
	);
};

